import React, { useState, useEffect } from 'react';
import { Paper, Grid, Avatar, Chip, Typography, InputAdornment, CircularProgress, TextField, IconButton, Card, CardContent, Pagination } from '@mui/material';
import ApiService from '../../functions/apiService';
import './checklist.css'
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Link, useNavigate, useParams } from "react-router-dom";
import EmptyState from '../../components/Error/EmptyState';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import Modal from 'react-bootstrap/Modal';
import { Row, Col } from 'react-bootstrap';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';


const ChecklistDetails = (props) => {
	const [addModal, setAddModal] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [generalModal, setGeneralModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const { id, scheduleId } = useParams();
	const [generalizedTicket, setGeneralizedTicket] = useState(null);
	const [disableItem, setDisableItem] = useState(false);
	const [itemName, setItemName] = useState('')
	const [ticketDetail, setTicketDetail] = useState('')
	const [title, setTitle] = useState('')
	const [details, setDetails] = useState('')

	const getChecklistData = () => {
		const body = {
			'checklist_id': id,
			"checklist_schedule_id": scheduleId
		}
		ApiService.post('/checklist/data', body)
			.then((data) => {
				setTitle(data?.title)
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	const getChecklistDetails = () => {
		const body = {
			'checklist_id': id,
			"checklist_schedule_id": scheduleId
		}
		ApiService.post('/checklist/schedule-results', body)
			.then((data) => {
				setDetails(data?.data?.checklist_item)
				setGeneralizedTicket(data?.data?.generalizedTicket)
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	useEffect(() => {
		getChecklistData()
		getChecklistDetails()
	}, [])

	let navigate = useNavigate();

	return (
		<>
			{loading ? (
				<Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
					<CircularProgress />
				</Paper>)
				:
				(<>
					<Paper className="p-4" style={{ marginTop: "1rem" }}>
						<Grid container className='align-items-center' gap={2} fontFamily={'karla'}>

							{/* Heading */}
							<Grid item xs={10} md={9} sx={{ minWidth: '80% !important' }}>
								<Typography variant="h5">
									<Link to={`/firehouse/checklist-schedule/${id}`} style={{ color: "black" }}>
										<ArrowBackIosIcon />
									</Link>
									{`Checklist > ${title}`}</Typography>  {/* ${(schedules?.title)} */}
							</Grid>

							{!details || details.length == 0 ?
								<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 300, width: "100%" }}>
									<img src='/images/blur-logo.png' style={{ height: 150 }} />
									<span className='mt-4' style={{ color: '#555555' }}>
										No Details Found
									</span>
								</div>
								:
								<Grid item className='align-items-center p-2' fontFamily={'karla'} md={12}>
									<Card sx={{ backgroundColor: 'rgba(245, 245, 245, 0.4)', border: '1px solid #cccccc', borderRadius: '12px' }} elevation={0}>
										<CardContent>
											<div className='check-items-heading row'>
												<span className='check-items col-md-5'>Decsription</span>
												<span className='check-items col-md-3'>Name</span>
												<span className='check-items col-md-2'>Status</span>
											</div>

											{details && details.length > 0 && details.map((item) => (
												<div className='row' style={{ marginTop: '15px', display: 'flex', alignItems: 'center' }}>

													<div className='col-md-5 d-flex align-items-center'>
														<span className='col-md-1 d-flex align-items-center'>
															{item?.location?.type == 'location' ?
																<img src='/images/Building.png' style={{ width: 30, height: 30 }} />
																: item?.location?.type == 'location_item' ?
																	<img src="/images/location-item.svg" style={{ width: 23, height: 23 }} />
																	:
																	<img src="/images/location-blue.svg" style={{ width: 25, height: 25 }} />
															}
														</span>

														<span className='col-md-10 p-0' style={{ color: !item?.description ? '#ccc' : 'inherit', pointerEvents: !item?.description ? 'none' : 'auto' }}>
															{item?.description || "--"}
														</span>
													</div>

													<div className='col-md-3'>
														<span>
															{(() => {
																const desc = item?.item_location?.item?.item_description || item?.location?.location_description;
																return desc ? desc.replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1)) : '';
															})()}
														</span>
													</div>

													<div className="col-md-2 check-item-card" style={{ gap: 10, justifyContent: 'left' }}>
														{item?.schedule_reports?.status == 'pass' ?
															<Chip
																variant="outlined"
																sx={{
																	backgroundColor: '#DDDDDD00',
																	color: '#2B3F6C',
																	border: '1px solid #2B3F6C80',
																	// cursor: 'pointer'
																}}
																avatar={<Avatar src="/images/check1.png" style={{ width: 30, height: 30, padding: 7 }} />}
																label={'Passed'}
															/>
															:
															item?.schedule_reports?.status == 'missing' ?
																<Chip
																	variant="outlined"
																	sx={{
																		backgroundColor: '#DDDDDD00',
																		color: '#B8860B',
																		border: '1px solid #F0AD4E',
																	}}
																	icon={<HelpOutlineIcon style={{ color: '#F0AD4E', fontSize: 20 }} />}
																	label={'Missing'}
																/>
															:
															item?.schedule_reports?.status == 'failed' ?
																<>
																	<Chip
																		variant="outlined"
																		sx={{
																			backgroundColor: '#DDDDDD00',
																			color: '#BF1D2D',
																			border: '1px solid #BF1D2D',
																			// cursor: 'pointer'
																		}}
																		avatar={<Avatar src="/images/red-cross.png" style={{ width: 24, height: 24, padding: 2 }} />}
																		label={'Failed'}
																	/>

																	{item?.schedule_reports?.checklist_ticket_id != null &&
																		<Chip
																			variant="outlined"
																			sx={{
																				backgroundColor: '#EAECF0',
																				color: '#2B3F6C',
																				border: '1px solid #2B3F6C',
																				cursor: 'pointer'
																			}}
																			avatar={<Avatar src="/images/eye.png" style={{ width: 24, height: 24, padding: 2 }} />}
																			label={'View Ticket'}
																			onClick={() => {
																				setTicketDetail(item)
																				setShowModal(true)
																			}}
																		/>
																	}
																</>
																:
																<>
																	<Chip
																		variant="outlined"
																		sx={{
																			color: '#2B3F6C',
																			border: '1px solid #2B3F6C',
																			// cursor: 'pointer'
																		}}
																		avatar={<Avatar src="/images/eye.png" style={{ width: 24, height: 24, padding: 2 }} />}
																		label={'Not Filled'}
																	/>
																</>
														}
													</div>
												</div>
											))}
										</CardContent>
									</Card>

									{/* View Generalize Ticket Button */}
									<Grid container gap={2} className='justify-content-end'>
										<Grid item xs={6} md={'auto'} className='btn-check-2'>
											<ButtonTheme type='submit' variant="filled" color='primary' className='px-4 mt-4'
												disabled={(!generalizedTicket || generalizedTicket == null)}
												onClick={() => {
													setGeneralModal(true)
													setDisableItem(true)
													setItemName('')
												}}>
												View Generalize Ticket
											</ButtonTheme>
										</Grid>
									</Grid>
								</Grid>
							}
						</Grid>
					</Paper >
				</>)}

			{/* View Ticket Pop-Up View */}
			<div className='font-fam'>
				<Modal className='checklist-modal' show={showModal} size="md" onHide={() => {
					setShowModal(false)
				}}>
					<Modal.Header closeButton>
						<Modal.Title>View Ticket</Modal.Title>
					</Modal.Header>
					<div className='ticket-item-heading'>{ticketDetail?.schedule_reports?.ticket?.title}</div>
					<Modal.Body >
						<Grid item xs={12} sm={6} md={6}>
							<div className='font-fam model-bg'>

								<div >
									<div className='ticket-margin row'>
										<div className='ticket-item'>{
										ticketDetail?.location?.type == "location_item" ? "Location & Item : " 
											: ticketDetail?.location?.type == "location" ? "Location : " 
											: "Item : "} 
										{ticketDetail?.location?.location_description || ticketDetail?.item_location?.item?.item_description} </div>
										{/* <div className='ticket-item'>Item : {ticketDetail?.checklist_item_name} </div> */}
										<div className='ticket-todo'>{ticketDetail?.schedule_reports?.ticket?.tickteting_status?.status &&
											ticketDetail?.schedule_reports?.ticket?.tickteting_status?.status?.charAt(0)?.toUpperCase() + ticketDetail?.schedule_reports?.ticket?.tickteting_status?.status?.slice(1)?.toLowerCase()}</div>
									</div>

									<div className='ticket-margin row'>
										<div style={{ color: '#000' }}>Assign To : <span style={{ color: '#555555' }}>{ticketDetail?.schedule_reports?.ticket?.assignee_employee_first_name ? (ticketDetail?.schedule_reports?.ticket?.assignee_employee_first_name + ' ' + ticketDetail?.schedule_reports?.ticket?.assignee_employee_last_name) : 'Unassigned'}</span> </div>
									</div>

									{/* <div className='ticket-margin row'>
										<div style={{ color: '#000' }}>Notify To : <span style={{ color: '#555555' }}>{ticketDetail?.schedule_reports?.ticket?.notify_employee_first_name ? (ticketDetail?.schedule_reports?.ticket?.notify_employee_first_name + ' ' + ticketDetail?.schedule_reports?.ticket?.notify_employee_last_name) : 'Unassigned'}</span> </div>
									</div> */}

									<div className="col-md-7 mt-1">
										<Typography variant="h6">
											Description
										</Typography>
									</div>

									<div className='row'>
										<div className='col' style={{ color: !ticketDetail?.schedule_reports?.ticket?.description ? '#ccc' : 'inherit', pointerEvents: !ticketDetail?.schedule_reports?.ticket?.description ? 'none' : 'auto' }}>
											{ticketDetail?.schedule_reports?.ticket?.description || "--"}
										</div>
									</div>

									<div className='row mt-2'>
										<div className='col'>
											<Typography variant="h6">
												Image
											</Typography>
											{ticketDetail?.schedule_reports?.ticket?.image || ticketDetail?.schedule_reports?.ticket?.secondary_image ? (
												<>
													{ticketDetail?.schedule_reports?.ticket?.image != null &&
														<img src={ticketDetail?.schedule_reports?.ticket?.image} width='100px' height='100px' style={{ marginTop: '10px', marginRight: '10px', borderRadius: '8px', border: '1px solid #cccccc' }} />
													}
													{ticketDetail?.schedule_reports?.ticket?.secondary_image != null &&
														<img src={ticketDetail?.schedule_reports?.ticket?.secondary_image} width='100px' height='100px' style={{ marginTop: '10px', borderRadius: '8px', border: '1px solid #cccccc' }} />
													}
												</>
											) :
												<p>No Image Uploaded</p>
											}
										</div>

									</div>
								</div>
							</div>
						</Grid>
					</Modal.Body>
				</Modal>
			</div >

			{/* View Ticket Generalized Pop-Up View */}
			< div className='font-fam' >
				<Modal className='checklist-modal' show={generalModal} size="md" onHide={() => {
					setGeneralModal(false)
				}}>
					<Modal.Header closeButton>
						<Modal.Title>View Generalized Ticket</Modal.Title>
					</Modal.Header>
					<div className='ticket-item-heading'>{generalizedTicket?.title}</div>
					<Modal.Body >
						<Grid item xs={12} sm={6} md={6}>
							<div className='font-fam model-bg'>

								<div >
									<div className='ticket-margin row'>
										<div className='ticket-item'>Generalized Ticket</div>
										<div className='ticket-todo'>{generalizedTicket?.tickteting_status?.status &&
											generalizedTicket.tickteting_status.status.charAt(0).toUpperCase() +
											generalizedTicket.tickteting_status.status.slice(1)}</div>
									</div>

									<div className='ticket-margin row'>
										<div style={{ color: '#000' }}>Assign To : <span style={{ color: '#555555' }}>{generalizedTicket?.employee_first_name ? (generalizedTicket?.employee_first_name + ' ' + generalizedTicket?.employee_last_name) : 'Unassigned'}</span> </div>
									</div>

									{/* <div className='ticket-margin row'>
										<div style={{ color: '#000' }}>Notify To : <span style={{ color: '#555555' }}>{generalizedTicket?.notify_employee_first_name ? (generalizedTicket?.notify_employee_first_name + ' ' + generalizedTicket?.notify_employee_last_name) : 'Unassigned'}</span> </div>
									</div> */}

									<div className="col-md-7 mt-1">
										<Typography variant="h6">
											Description
										</Typography>
									</div>

									<div className='row'>
										<div className='col' style={{ color: !generalizedTicket?.description ? '#ccc' : 'inherit', pointerEvents: !generalizedTicket?.description ? 'none' : 'auto' }}>
											{generalizedTicket?.description || "--"}
										</div>
									</div>

									<div className='row mt-2'>
										<div className='col'>
											<Typography variant="h6">
												Image
											</Typography>
											{generalizedTicket?.image || generalizedTicket?.secondary_image ? (
												<>
													{generalizedTicket?.image != null &&
														<img src={generalizedTicket?.image} width='100px' height='100px' style={{ marginTop: '10px', marginRight: '10px', borderRadius: '8px', border: '1px solid #cccccc' }} />
													}
													{generalizedTicket?.secondary_image != null &&
														<img src={generalizedTicket?.secondary_image} width='100px' height='100px' style={{ marginTop: '10px', borderRadius: '8px', border: '1px solid #cccccc' }} />
													}
												</>
											) :
												<p>No Image Uploaded</p>
											}
										</div>
									</div>
								</div>
							</div>

						</Grid>
					</Modal.Body>
				</Modal>
			</div >
		</>
	)
}
export default ChecklistDetails